import { Modal } from '@/components/ui/Modal';

export interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'default';
}

export function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'default',
}: ConfirmDialogProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      footer={
        <>
          <button
            onClick={onClose}
            className="px-3.5 py-1.5 rounded-lg border border-border bg-surface text-sm font-medium text-text-secondary cursor-pointer hover:bg-page transition-all"
          >
            {cancelLabel}
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className={`px-3.5 py-1.5 rounded-lg border-none text-white text-sm font-medium cursor-pointer transition-all ${
              variant === 'danger'
                ? 'bg-red-600 hover:bg-red-700'
                : 'bg-baker-red hover:bg-baker-red/90'
            }`}
          >
            {confirmLabel}
          </button>
        </>
      }
    >
      <p className="m-0 text-text-secondary text-sm leading-relaxed">{message}</p>
    </Modal>
  );
}
